import { createSlice } from '@reduxjs/toolkit';

// project imports
import rackAxiosServices from 'utils/rackAxiosServices';

import { dispatch } from '../index';

const initialState = {
  error: null,
  grower6040s: [],
  grower6040: {},
  metrics: {},
  loading6040: false,
};

const grower6040 = createSlice({
  name: 'grower6040',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload.error;
    },
    // ADD 6040  Information
    add6040InformationSuccess(state, action) {
      state.grower6040 = action.payload.grower6040Info;
    },
    // UPDATE 6040  Information
    update6040InformationSuccess(state, action) {
      state.grower6040 = action.payload.updateInformation;
    },
    setLoading6040(state, action) {
      state.loading6040 = action.payload;
    },
    delete6040Success: (state, action) => {
      const id = action.payload;
      // eslint-disable-next-line
      state.grower6040s = state.grower6040s.filter(grower6040 => grower6040.grower6040uuid !== id);
      // eslint-disable-next-line
      state.grower6040 = {};
    },
    
    get6040Success(state, action) {
      state.grower6040 = action.payload;
  },
    getGrower6040sSuccess(state, action) {
        state.grower6040s = action.payload;
    },
    clearCurrent6040Data(state, action) {
      state.grower6040 = {};
    },
    clearCurrent6040Metrics(state, action) {
      state.metrics = {};
    },
    logic6040Success(state, action) {
      state.metrics = action.payload;
    }
  }
});

// Reducer
export default grower6040.reducer;
export const { clearCurrent6040Data, clearCurrent6040Metrics } = grower6040.actions;
// advisor workbook functions
export function save6040Information(grower6040Info) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_6040_API_URL, { ...grower6040Info });
      dispatch(grower6040.actions.add6040InformationSuccess(grower6040Info));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower6040.actions.hasError(axiosError));
    }
  };
}

export function update6040Information(grower6040Info) {
  return async () => {
    try {
      await rackAxiosServices.put(process.env.REACT_APP_6040_API_URL, { ...grower6040Info });
      dispatch(grower6040.actions.update6040InformationSuccess(grower6040Info));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      console.log("errror", axiosError)
      dispatch(grower6040.actions.hasError(axiosError));
    }
  };
}
export function delete6040(id) {
  return async (dispatch) => {
    try {
      const url = process.env.REACT_APP_6040_API_URL;
        // eslint-disable-next-line prefer-template
        const response = await rackAxiosServices.delete(url + "/object/" + id);
        dispatch(grower6040.actions.delete6040Success(response.data));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(grower6040.actions.hasError(axiosError));
      console.log(error);
    }
  };
}

export function get6040(grower6040Uuid) {
    return async () => {
      try {
        dispatch(grower6040.actions.setLoading6040(true));
        const url = process.env.REACT_APP_6040_API_URL + '/' + grower6040Uuid;
        const response = await rackAxiosServices.get(url);
        dispatch(grower6040.actions.get6040Success(response.data[0]));
        dispatch(grower6040.actions.setLoading6040(false));
      } catch (error) {
  
        const axiosError = {
          message: error.message,
          status: error.status,
          code: error.code
        };
        console.log(`Error from axios call ${JSON.stringify(axiosError)}`);
  
        dispatch(grower6040.actions.hasError(axiosError));
      }
    };
  }
  
  export function get6040sByGrowerId(growerUuid) {
    return async () => {
      try {
        dispatch(grower6040.actions.setLoading6040(true));
        const url = process.env.REACT_APP_6040_API_URL + '/grower/' + growerUuid;
        const response = await rackAxiosServices.get(url);

        dispatch(grower6040.actions.getGrower6040sSuccess(response.data));
        dispatch(grower6040.actions.setLoading6040(false));
      } catch (error) {
        const axiosError = {
          message: error.message,
          status: error.status,
          code: error.code
        };
        console.log(`Error from axios call`, error);
  
        dispatch(grower6040.actions.hasError(axiosError));
      }
    };
  }

  export function get6040Calculations(form6040Values){
    console.log("Form6040Values in action: ", form6040Values);
    return async () => {
      try {
        const url = process.env.REACT_APP_BUS_LOGIC_URL + '/6040-calculations';
        const response = await rackAxiosServices.post(url, form6040Values);

        dispatch(grower6040.actions.logic6040Success(response.data));
      } catch (error) {
        console.log(`Error from axios call ${JSON.stringify(error.response.data)}`);
  
        dispatch(grower6040.actions.hasError(error.response.data));
      }
    };
  }